// トップページ以外・width>=1024 で .l-main__aside をスクロール追従させる
export function initStickyAside(): void {
  if (document.body.classList.contains("home")) return;

  const aside = document.querySelector<HTMLElement>(".l-main__aside");
  const openButton = document.querySelector<HTMLElement>(".js-modal-open");
  if (!aside || !openButton) return;

  const BREAKPOINT = 1024;

  const update = () => {
    if (window.innerWidth >= BREAKPOINT) {
      const buttonBottom = openButton.getBoundingClientRect().bottom;
      aside.style.position = "sticky";
      aside.style.top = `${buttonBottom + 16}px`;
    } else {
      aside.style.position = "";
      aside.style.top = "";
    }
  };

  let rafId = 0;
  const requestUpdate = () => {
    if (rafId) cancelAnimationFrame(rafId);
    rafId = requestAnimationFrame(update);
  };

  update();
  window.addEventListener("resize", requestUpdate);
  window.addEventListener("orientationchange", requestUpdate);
  window.addEventListener("load", requestUpdate);
}
